import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export default function Filter({
    realisation,
    setFiltered,
    activeCategory,
    setActiveCategory
}) {
    const { t } = useTranslation();

    useEffect(() => {
        if(activeCategory === 0) {
            setFiltered(realisation)
            return
        }

        const filtered = realisation.filter((real) =>
            real.category === activeCategory
        )
        setFiltered(filtered)
    }, [activeCategory, realisation, setFiltered])

  return (
    <div className='realisations-filter'>
        <button 
            className={activeCategory === 0 ? "active" : ""}
            onClick={() => setActiveCategory(0)}
        >{t('portfolio.categories.all')}</button>
        <button 
            className={activeCategory === "siteweb" ? "active" : ""}
            onClick={() => setActiveCategory("siteweb")}
        >{t('portfolio.categories.siteweb')}</button>
        <button 
            className={activeCategory === "identitevisuelle" ? "active" : ""}
            onClick={() => setActiveCategory("identitevisuelle")}
        >{t('portfolio.categories.identitevisuelle')}</button>
        <button 
            className={activeCategory === "logo" ? "active" : ""}
            onClick={() => setActiveCategory("logo")}
        >{t('portfolio.categories.logo')}</button>
        <button 
            className={activeCategory === "illustration" ? "active" : ""}
            onClick={() => setActiveCategory("illustration")}
        >{t('portfolio.categories.illustration')}</button>
        <button 
            className={activeCategory === "application" ? "active" : ""}
            onClick={() => setActiveCategory("application")}
        >{t('portfolio.categories.application')}</button>
        <button 
            className={activeCategory === "dessin" ? "active" : ""}
            onClick={() => setActiveCategory("dessin")}
        >{t('portfolio.categories.dessin')}</button>
    </div>
  )
}
